import { render } from "./PackingListList.vue?vue&type=template&id=2737d6c4"
import script from "./PackingListList.vue?vue&type=script&lang=js"
export * from "./PackingListList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__